module.exports = __webpack_public_path__ + "img/fontawesome-webfont.woff?fee66e712a8a08eef5805a46892932ad";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 596
// module chunks = 0